import useSWR from 'swr'

export interface MailDataType {
    state: number,
    mailaddress: string,
    language: string
    fisicalyear: number
}

/**
 * メール登録情報を取得する。
 * state: 1:登録受付 2:登録済み 3:タイムアウト
 * mailaddress: メールアドレス
 * language: ja or en
 */
export function useMailData(id?:string | null) {

    const fetchAddress = `/competition/api/registration/ktr011?id=${id}`;
    // const fetchAddress = `http://localhost:3100/ktr011/${id}`;

    const fetcher = () => fetch(fetchAddress).then(res => res.json());

    const {data, error, isLoading, mutate} = useSWR(`MailData`, fetcher, {revalidateOnFocus:false, revalidateOnReconnect:false});

    return{
        MailData: data,
        isLoadingMailData: isLoading,
        isError: error,
        mutate,
    }
}